import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { Modal } from 'reactstrap';
import { toggleLoading } from '../../../Redux/reducers/loadingSlice';
import { TOKEN_KEY } from '../../../Utils/Constants';
import { baseUrl } from '../../../shared/baseUrl';
import { createNotification } from '../CreateNotification';
import './ToggleSold.css';

export default function ToggleSold({ isSold, productId }) {

    const dispatch = useDispatch();
    const [checkOn, setCheckOn] = useState(!isSold);
    const [alertOpen, setAlertOpen] = useState(false);

    const changeProductStatus = async () => {
        dispatch(toggleLoading(true));
        await fetch(baseUrl + "update-sold-status", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem(TOKEN_KEY) !== null ? 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token : null
            },
            body: JSON.stringify({
                product_id: productId,
                is_sold: checkOn ? 1 : 0
            })
        })
            .then((res) => res.json())
            .then((res) => {
                dispatch(toggleLoading(false));
                if (res.success) {
                    createNotification('success', res.message);
                    setCheckOn(!checkOn);
                } else {
                    createNotification('error', res.message);
                }

            })
            .catch((e) => {
                dispatch(toggleLoading(false));
                createNotification('error', e.message);
            })

    }


    return (
        <div className="toggle-switch" onClick={(e) => { e.stopPropagation(); setAlertOpen(true) }} >
            <div
                className={`toggle-switch-checkbox ${!checkOn ? 'checked' : ''}`}
                name="toggle"
                id="toggle"
            />
            <label className="toggle-switch-label" htmlFor="toggle">
                <span className="toggle-switch-inner" />
                <span className="toggle-switch-switch" />
            </label>
            <Modal isOpen={alertOpen} centered className='p-3'>
                <div onClick={() => { setAlertOpen(false); }} className='position-absolute cursor-pointer' style={{ zIndex: 10, top: 6, right: 10 }}>
                    <FaTimes size={20} />
                </div>
                <div className='py-4 px-3'>
                    <h3>{checkOn ? 'Are you sure you want to make it as sold?' : 'Are you sure you want to make it as live?'}</h3>
                    <p>{checkOn ? 'If you set the item to sold, it means you have sold your item to a user. So this item will be no longer shown to other users!'
                        : 'If you set the item to live, it means you haven\'t sold your item. So this item will be  shown to all the other users!'}</p>
                    <div>
                        <button className="btn btn-danger" onClick={() => {
                            setAlertOpen(false);
                            changeProductStatus();
                        }}>Yes</button>
                        <button className="btn btn-success ms-3" onClick={() => {
                            setAlertOpen(false);
                        }}>No</button>
                    </div>
                </div>
            </Modal>
        </div>

    );

}